import "core-js/modules/es.array.concat.js";
import { request } from '@/api/index';
import { api3 } from '@api/env';
export function create(taskId, data) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId),
    method: 'post',
    data: data,
    withCredentials: false,
    output: true
  });
}
export function update(taskId, data) {
  var customHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId),
    method: 'post',
    data: data,
    withCredentials: false,
    customHeaders: customHeaders
  });
}
export function remove(confirmId, taskId) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/").concat(confirmId),
    method: 'delete',
    withCredentials: false,
    getHeaders: true
  });
}
export function toGetEcodeDetail(confirmId, taskId) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/").concat(confirmId, "/ecRequest"),
    method: 'post',
    withCredentials: false,
    getHeaders: true
  });
}
export function getDetail(confirmId, taskId) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/").concat(confirmId),
    method: 'get',
    withCredentials: false,
    getHeaders: true
  });
}
export function getHistoryDetail(confirmId, taskId) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/").concat(confirmId, "/archived"),
    method: 'get',
    withCredentials: false,
    getHeaders: true
  });
}
export function updateDetail(taskId, confirmId, data) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/").concat(confirmId),
    method: 'put',
    withCredentials: false,
    data: data,
    getHeaders: true
  });
}
export function removeDetail(confirmId, taskId) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/").concat(confirmId),
    method: 'delete',
    withCredentials: false,
    getHeaders: true
  });
}
export function batchFlow(taskId, data) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/flow"),
    method: 'post',
    withCredentials: false,
    data: data
  });
}
export function batchDelData(taskId, data) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/delete"),
    method: 'post',
    data: data
  });
}
export function updateECodeStatus(taskId, data) {
  return request({
    baseURL: api3,
    url: "/api/Tasks/".concat(taskId, "/batchUpdateStatus"),
    method: 'post',
    customWithCredentials: false,
    data: data
  });
}
export function batchUpdateGetStaff(data) {
  return request({
    baseURL: api3,
    url: '/api/confirmations',
    method: 'put',
    withCredentials: false,
    data: data
  });
}
export function testSingleC02(taskId, params) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/single"),
    method: 'post',
    withCredentials: false,
    params: params
  });
}
export function uploadJsonData(taskId, data) {
  return request({
    baseURL: api3,
    url: "/api/tasks/".concat(taskId),
    method: 'post',
    withCredentials: false,
    data: data
  });
}
export function getParamList(confirmId, taskId, params) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/").concat(confirmId, "/confirmData"),
    method: 'get',
    withCredentials: false,
    getHeaders: true,
    params: params
  });
}
export function getHistoryParamList(confirmId, taskId, params) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/").concat(confirmId, "/confirmData/archived"),
    method: 'get',
    withCredentials: false,
    getHeaders: true,
    params: params
  });
}
export function toBatchSend(data) {
  return request({
    baseURL: api3,
    url: '/api/confirmations/batchSend',
    method: 'post',
    withCredentials: false,
    data: data,
    output: true
  });
}
export function toBatchRewind(data, params) {
  return request({
    baseURL: api3,
    url: '/api/confirmations/batchRewind',
    method: 'post',
    withCredentials: false,
    data: data,
    params: params,
    output: true
  });
}
export function toGet(data) {
  return request({
    baseURL: api3,
    url: '/api/confirmations/batchRewind',
    method: 'post',
    withCredentials: false,
    data: data,
    output: true
  });
}
export function toCheckCodes(data) {
  return request({
    baseURL: api3,
    url: '/api/confirmations/crossCheck',
    method: 'post',
    withCredentials: false,
    data: data
  });
}
export function toBatchGetExpress(data) {
  return request({
    baseURL: api3,
    url: '/api/confirmations/queryReceiptInfo',
    method: 'post',
    withCredentials: false,
    data: data,
    output: true
  });
}
export function getExpressInfo(taskId, confirmId, params) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/").concat(confirmId, "/tracking"),
    method: 'get',
    withCredentials: false,
    params: params
  });
}
export function getParamDetail(confirmId, taskId, confirmDataId) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/").concat(confirmId, "/confirmData/").concat(confirmDataId),
    method: 'get',
    withCredentials: false,
    getHeaders: true
  });
}
export function updateParam(confirmId, taskId, confirmDataId, data) {
  var customHeaders = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/").concat(confirmId, "/confirmData/").concat(confirmDataId),
    method: 'put',
    withCredentials: false,
    getHeaders: true,
    data: data,
    customHeaders: customHeaders
  });
}
export function removeParam(confirmId, taskId, confirmDataId, data) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/").concat(confirmId, "/confirmData/").concat(confirmDataId),
    method: 'delete',
    withCredentials: false,
    getHeaders: true,
    data: data
  });
}
export function createParam(confirmId, taskId, data) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/").concat(confirmId, "/confirmData"),
    method: 'post',
    withCredentials: false,
    getHeaders: true,
    data: data
  });
}
export function uploadByCreator(confirmId, taskId, data) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/").concat(confirmId, "/uploadFile"),
    method: 'post',
    data: data
  });
}
export function uploadByCpsccAdmin(confirmId, data) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/".concat(confirmId, "/uploadFile"),
    method: 'post',
    data: data
  });
}
export function downloadFileByCreator(confirmId, taskId, params) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/").concat(confirmId, "/downloadFile"),
    method: 'get',
    params: params,
    responseType: 'blob'
  });
}
export function downloadHistoryFileByCreator(confirmId, taskId, params) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(taskId, "/").concat(confirmId, "/downloadFile/archived"),
    method: 'get',
    params: params,
    responseType: 'blob'
  });
}
export function downloadFileByCpsccAdmin(confirmId, params) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/tasks/".concat(confirmId, "/downloadFile"),
    method: 'get',
    responseType: 'blob',
    params: params
  });
}

// 聚合下单相关

export function toSendViaSf(data) {
  return request({
    baseURL: api3,
    url: '/api/confirmations/sendViaSf',
    method: 'post',
    withCredentials: false,
    data: data
  });
}
export function toGetOrderRecords(params) {
  return request({
    baseURL: api3,
    url: '/api/confirmations/getOrderRecords',
    method: 'get',
    withCredentials: false,
    params: params
  });
}
export function toReorder(data) {
  return request({
    baseURL: api3,
    url: '/api/confirmations/reorderSf',
    method: 'post',
    withCredentials: false,
    data: data
  });
}
export function toGetFetchSfWaybills(data) {
  return request({
    baseURL: api3,
    url: '/api/confirmations/fetchSfWaybills',
    method: 'post',
    withCredentials: false,
    data: data
  });
}
export function toGetFetchSfWaybills2(id, code, phone) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/fetchSfExternalWaybills/".concat(id, "/").concat(code).concat(phone ? "/".concat(phone) : ''),
    method: 'get',
    withCredentials: false
  });
}
export function toUpdateList(data) {
  return request({
    baseURL: api3,
    url: '/api/confirmations/UpdateSfOrdersByStatus',
    method: 'post',
    withCredentials: false,
    data: data,
    output: true
  });
}
export function toGetRoute(data) {
  return request({
    baseURL: api3,
    url: '/api/confirmations/fetchSfRoutes',
    method: 'post',
    withCredentials: false,
    data: data
  });
}
export function toGetRoute2(params) {
  return request({
    baseURL: api3,
    url: '/api/confirmations/getSfRoute',
    method: 'get',
    withCredentials: false,
    params: params,
    output: true
  });
}
export function toGetSendRoute(code) {
  return request({
    baseURL: api3,
    url: "/api/confirmations/ParseRoute/".concat(code),
    method: 'post',
    withCredentials: false,
    output: true
  });
}